/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Heart from './heart-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Heart {...validProps} />;
}
SvgComponent.iconName = 'heart';

export const HeartIcon = svgIconWrapper(SvgComponent);
